import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';

import 'nprogress/nprogress.css';
import App from 'src/App';
import { SidebarProvider } from 'src/contexts/SidebarContext';
import * as serviceWorker from 'src/serviceWorker';
import { Provider } from 'react-redux';
import { store } from './store';
import { Toaster } from 'react-hot-toast';

import { NavigateSetter } from './utils/navigate/NavigateSetter';

const container = document.getElementById('root');
if (container) {
  const root = ReactDOM.createRoot(container);
  root.render(
    <Provider store={store}>
      <HelmetProvider>
        <SidebarProvider>
          <BrowserRouter basename="/">
            <NavigateSetter />
            <App />
            <Toaster position="top-right" reverseOrder={false} />
          </BrowserRouter>
        </SidebarProvider>
      </HelmetProvider>
    </Provider>
  );
}

serviceWorker.unregister();
